module.exports = __webpack_public_path__ + "img/arrow-right.0fe1f9fc.png";